<template>
  <v-container class="mb-5 mxw-100pc pb-0 pt-0 px-0" style="padding-left: 0px !important; padding-right: 0px !important;" v-resize="onResize">
    <div class="mx-auto" style="margin-bottom: 600px;" v-if="!loaded">
      <b-loading></b-loading>
    </div>

    <v-toolbar class="lightly-shadowed" fixed height="64px" v-show="loaded">
      <div class="px-3" v-if="$route.params.listId">
        <v-icon class="fs-28 mr-3">favorite</v-icon>
          <span class="fs-24 fw-500">{{ listName }}</span>
        </div>
        <b-filters :mode="mode" :search="search" @redraw="onResize" @swap="changeMode" @update="updateSearch()" v-if="$route.params.searchId && loaded && search.coverage"></b-filters>
    </v-toolbar>

    <div style="position: absolute; bottom: 0px; top: 68px; width: 100%;" v-show="loaded">
      <div :style="listClass" id="list">
        <div class="px-3 pt-4" style="height: 100%;" v-if="rough_matches.length == 0">
          <v-row>
            <v-col class="pxy-0">
              <p class="fs-16 fw-500">Oops! We couldn't find any providers in your area.</p>
              <p class="fs-16 fw-500">This is likely due to an issue with our search engine and our support team has been notified.</p>
            </v-col>
          </v-row>
        </div>

        <div class="px-3 pt-4" v-for="(match, index) in matches" :key="index">
          <v-row>
            <v-col class="px-3 py-1">
              <v-card class="bc-pale-gray b-1 elevation-0">
                <v-card-text class="px-3 py-1 lh-normal">
                  <b-match :id="match.id" :key="match.id" :match="match" :search="search" @details="openDetails" @mouseover.native="selectedMatch = match" @satelliteview="openSatelliteView" @streetview="openStreetView" class="mx-auto px-2 py-1"></b-match>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div v-show="matches.length > 0">
          <v-row>
            <v-col class="mt-3 mb-3 ta-center">
              <v-btn :disabled="!paginator.fewerPages()" @click="paginate(-1)" class="d-inline-block mr-3" color="primary" text="">
                <v-icon color="primary">chevron_left</v-icon>
                <span>Previous</span>
              </v-btn>
              <v-btn :disabled="!paginator.morePages()" @click="paginate(1)" class="d-inline-block ml-3" color="primary" text="">
                <span>Next</span>
                <v-icon color="primary">chevron_right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <div :style="mapClass">
        <gmap-map :center="center" :options="{ zoomControl: true, mapTypeControl: false, scaleControl: true, streetViewControl: false, rotateControl: false, fullscreenControl: false, disableDefaultUi: true }" :zoom="13" ref="mapRef" style="width:100%;  height: 100%;">
          <gmap-marker :icon="{ url: $assets.icons.home }" :position="search.home" v-if="search.origin"></gmap-marker>
          <gmap-marker :icon="{ url: $assets.icons.business }" :position="search.work" v-if="search.destination && search.location_type == 'commute'"></gmap-marker>
          <gmap-marker :clickable="true" :icon="{ url: ( match == selectedMatch ? selectedMarker : marker), scaledSize: ( match == selectedMatch ? { width: 46, height: 46, f: 'px', b: 'px' } : { width: 36, height: 36, f: 'px', b: 'px' } ) }" :key="match.id" :position="{ lat: match.latitude, lng: match.longitude }" @click="select(match)" v-for="match in matches"></gmap-marker>
          <gmap-info-window :opened="infoOpened" :position="{ lat: selectedMatch.latitude, lng: selectedMatch.longitude }" @closeclick="infoOpened=false" v-if="selectedMatch">
            <b-match :match="selectedMatch" :search="search" @details="openDetails" class="mx-auto px-2 py-1 fullwidth overflow-hidden"></b-match>
          </gmap-info-window>
        </gmap-map>
      </div>
    </div>

    <v-dialog fullscreen="" v-if="detailedMatch" v-model="detailsDialogIsVisible">
      <b-match-details :match="detailedMatch" @close="detailsDialogIsVisible=false"></b-match-details>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '../services/bright_finder.js'
import Creating from '../components/search/creating.vue'
import Details from '../components/search/details.vue'
import Match from '../components/search/match.vue'
import Filters from '../components/search/filters.vue'
import firebase from 'firebase'

import { AgeComparison } from '../services/age_comparison.js'
import { AvailabilityComparison } from '../services/availability_comparison.js'
import { Coord } from '../services/coord.js'
import { SearchParams } from '../services/search_params.js'
import { HoursComparison } from '../services/hours_comparison.js'
import { MatchComparison } from '../services/match_comparison.js'
import { Paginator } from '../services/paginator.js'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loaded = false
      vm.load()
    })
  },

  components: {
    'b-filters': Filters,
    'b-loading': Creating,
    'b-match': Match,
    'b-match-details': Details
  },

  computed: {
    listClass() {
      if(!this.size || (this.size >= 960)) {
        return "width: 50%; overflow-y: scroll; display: inline-block; height: 100%;"
      } else {
        if(this.mode == 'list') {
          return 'width: 100%; overflow-y: scroll; height: 100%;'
        } else {
          return 'display: none;'
        }
      }
    },

    mapClass() {
      if(!this.size || (this.size >= 960)) {
        return "position: fixed; right: 0; bottom: 0; top: 134px; width: 50%; overflow-y: hidden;"
      } else {
        if(this.mode == 'map') {
          return 'width: 100%; overflow-y: scroll; height: 100%;'
        } else {
          return 'display: none;'
        }
      }
    }
  },

  data: function() {
    return {
      base_transit_time: 0,
      center: { lat: 0, lng: 0 },
      detailedMatch: null,
      detailsDialogIsVisible: false,
      directionsService: null,
      directionDisplay: null,
      infoOpened: false,
      infoOptions: { content: '' },
      listing: {},
      listName: null,
      loaded: false,
      step: 0,
      map: null,
      matches: [],
      mode: 'list',
      photoViewDialogIsVisible: false,
      satelliteViewDialogIsVisible: false,
      satelliteViewPosition: '',
      search: {},
      secondaryDirectionDisplay: null,
      selectedMarker: "https://bridgecarefinance-media.s3-us-west-2.amazonaws.com/images/selectedMarker.svg",
      size: null,
      streetViewDialogIsVisible: false,
      streetViewPosition: '',
      transitionName: '',
      selectedMatch: null,
      toggle_view: 0,
      marker: "https://bridgecarefinance-media.s3-us-west-2.amazonaws.com/images/marker.svg",
      paginator: new Paginator(0, 25, 300),
      rough_matches: [],
    }
  },

  methods: {
    applyCoverage: function(p) {
      p.ages_coverage = this.coversAges(p)
      p.hours_coverage = this.coversHours(p)
      p.availability_coverage = this.coversAvailability(p)
      return p
    },

    applyPage: function() {
      this.matches = []
      var vm = this
      setTimeout(function() {
        vm.matches = vm.rough_matches.slice(vm.paginator.beginning(), vm.paginator.end())
        vm.matches.forEach(vm.applySocial, vm)
      }, 25)
    },

    applySocial: function(p) {
      let provider = this.$store.state.providers[p.id]
      if(provider) {
        var match = this.matches.find(function(m) { return m.id == provider.id })
        match.yelp_business = provider.yelp_business
        match.google_place = provider.google_place
      } else {
        var vm = this
        Api.provider.get(p.id, function(resp) {
          vm.$store.commit('addProvider', resp.data)
          var match = vm.matches.find(function(m) { return m.id == resp.data.id })
          match.yelp_business = resp.data.yelp_business
          match.google_place = resp.data.google_place
        })
      }
    },

    changeMode: function(new_mode) {
      this.mode = new_mode
    },

    coversAges: function(provider) {
      return new AgeComparison(provider.ages, this.search.min_age, this.search.max_age).resolve()
    },

    coversAvailability: function(provider) {
      return new AvailabilityComparison(provider.availability, this.search.min_age, this.search.max_age).resolve()
    },

    coversHours: function(provider) {
      return new HoursComparison(this.search.coverage.split(","), this.search.dropoff, this.search.pickup, provider.hours).resolve()
    },

    load: function() {
      this.loaded = false
      var vm = this
      firebase.auth().currentUser.getIdTokenResult(true).then((idTokenResult) => {
        window.bf_api_token = idTokenResult.claims.bfToken

        vm.loadFavorites()
        vm.loadLists()

        if(vm.$route.params.searchId) {
          Api.search.get(vm.$route.params.searchId,
            function(resp) {
              vm.$store.commit('setSearch', resp.data)
              vm.setSearch(resp.data)
            })
        } else if(vm.$route.params.listId) {
          Api.list.get(vm.$route.params.listId,
            function(resp) {
              vm.listName = resp.data.name
              vm.rough_matches = resp.data.matches
              vm.center = new Coord(vm.rough_matches[0])
              vm.paginator = new Paginator(0, 25, vm.rough_matches.length)
              vm.applyPage()
              vm.loaded = true
            })
        }
      })
    },

    loadFavorites: function() {
      var vm = this
      Api.favorite.index(function(resp) {
        vm.$store.commit('updateFavorites', resp.data)
      })
    },

    loadLists: function() {
      var vm = this
      Api.list.index(function(resp) {
        vm.$store.commit('updateLists', resp.data)
      })
    },

    paginate: function(num) {
      this.paginator.paginate(num)
      this.applyPage()
    },

    openDetails: function(match) {
      var vm = this
      if(this.$route.params.searchId) {
        this.route(this.search.home, this.search.work, [{ location: new Coord(match), stopover: true }], function(transit_time) {
          match.added_transit_time =  transit_time - vm.base_transit_time
          vm.detailedMatch = match
          vm.detailsDialogIsVisible = true
        })
      } else {
        vm.detailedMatch = match
        vm.detailsDialogIsVisible = true
      }
    },

    onResize() {
      this.size = window.innerWidth
    },

    select: function(r) {
      this.selectedMatch = null
      this.selectedMatch = r
      this.infoOpened = true
      if(this.search && this.search.origin && this.search.destination) {
        this.route(this.search.home, this.search.work, [{ location: new Coord(r), stopover: true }])
      }
    },

    setSearch: function(data) {
      this.search = data
      this.rough_matches = data.matches.map(this.applyCoverage, this).sort(this.sortMatches)
      this.paginator = new Paginator(0, 25, this.rough_matches.length)
      this.applyPage()

      var vm = this
      vm.center = new Coord(data.center)
      if(vm.search.origin) {
        vm.search.formatted_origin = [vm.search.origin.address, vm.search.origin.city, vm.search.origin.state]
      }
      if(vm.search.destination) {
        vm.search.formatted_destination = [vm.search.destination.address, vm.search.destination.city, vm.search.destination.state]
      }
      if(vm.search.origin && vm.search.destination && vm.search.location_type == 'commute') {
        vm.route(vm.search.home, vm.search.work, [], function(transit_time) {
          vm.base_transit_time = transit_time
        })
      }
      vm.loaded = true
    },

    sortMatches: function(a, b) {
      return new MatchComparison(a, b, this.search.location_type).resolve()
    },

    route: function(origin, destination, waypoints = [], callback) {
      if(!this.directionsService) {
        this.directionsService = new window.google.maps.DirectionsService()
      }
      if(!this.directionsDisplay) {
        this.directionsDisplay = new window.google.maps.DirectionsRenderer({ polylineOptions: { strokeColor: "#1F5E70", strokeWeight: "6" } })
        this.directionsDisplay.setMap(this.map)
        this.secondaryDirectionsDisplay = new window.google.maps.DirectionsRenderer({ polylineOptions: { strokeColor: "#1F5E70", strokeWeight: "6" } })
        this.secondaryDirectionsDisplay.setMap(this.map)
      }

      this.directionsDisplay.setDirections({routes: []})
      this.secondaryDirectionsDisplay.setDirections({routes: []})
      var vm = this
      if(this.search.location_type == 'commute') {
        if(this.search.travel_mode == 'TRANSIT') {
          vm.directionsService.route({ origin: origin, destination: (waypoints[0] ? waypoints[0].location : destination), travelMode: 'TRANSIT' }, function (response, status) {
            if (status === 'OK') {
              vm.directionsDisplay.setOptions({ suppressMarkers: true, preserveViewport: true })
              vm.directionsDisplay.setDirections(response)
              var duration = response.routes[0].legs.reduce(function(sum, leg) { return sum + leg.duration.value }, 0)
              if(waypoints[0]) {
                vm.directionsService.route({ origin: waypoints[0].location, destination: destination, travelMode: 'TRANSIT' }, function (response, status) {
                  if (status === 'OK') {
                    vm.secondaryDirectionsDisplay.setOptions({ suppressMarkers: true, preserveViewport: true })
                    vm.secondaryDirectionsDisplay.setDirections(response)
                    if(callback) {
                      duration = duration + response.routes[0].legs.reduce(function(sum, leg) { return sum + leg.duration.value }, 0)
                      callback(duration)
                    }
                  }
                })
              }
            }
          })
        } else {
          vm.directionsService.route({ origin: origin, destination: destination, travelMode: (this.search.travel_mode || 'DRIVING'), waypoints }, function (response, status) {
            if (status === 'OK') {
              vm.directionsDisplay.setOptions({ suppressMarkers: true, preserveViewport: true })
              vm.directionsDisplay.setDirections(response)
              if(callback) {
                callback(response.routes[0].legs.reduce(function(sum, leg) { return sum + leg.duration.value }, 0))
              }
            }
          })
        }
      } else if (callback) {
        callback()
      }
    },

    updateSearch: function() {
      this.loaded = false
      var vm = this
      var params = new SearchParams(this.search)
      Api.search.update(this.search.id, params.asJson(), function(resp) {
        vm.setSearch(resp.data)
      })
    },

    openSatelliteView: function(position) {
      this.satelliteViewPosition = position
      this.satelliteViewDialogIsVisible = true
    },

    openStreetView: function(position) {
      this.streetViewPosition = position
      this.streetViewDialogIsVisible = true
    },
  },

  mounted: function() {
    var vm = this
    this.$refs.mapRef.$mapPromise.then(function(map) {
      vm.map = map
    })
  },

  watch: {
    '$route': function(to, from) {
      this.$vuetify.goTo("#app");
      if(to.meta.depth > from.meta.depth) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    },

    selectedMatch: function(newVal) {
      if(!newVal) { return }
    }
  }
}
</script>
